import { Box, Container } from "@mui/material";
import DeviceTable from "../components/DeviceTable";

function Device(props) {
    return (
        <Container maxWidth={false}>
            <Box mt={5} justifyContent='center'>
                <DeviceTable/>
            </Box>
        </Container>
    );
}

export default Device